export function getRandomIndexFromArray(array: unknown[]) {
  return Math.floor(Math.random() * Math.floor(array.length));
}
